import { atom } from 'recoil';
import { RECOIL_BASE_KEY } from '../constants';
import { Facility } from '../graphql/graphql.generated';

export const selectedFacilitiesAtom = atom<Facility[]>({
  key: `${RECOIL_BASE_KEY}SelectedFacilitiesAtom`,
  default: []
});
